import { TInitialState } from '@r1-frontend/service-engineer-visit/reducer/initialState';

const moreSlotsButtonIsDisabled = (state: TInitialState) => {
    return (state._incomingData?.maxNumberOfDays !== undefined &&
        state._requestedDays >= state._incomingData.maxNumberOfDays
    ) || state._loading;
};

export default moreSlotsButtonIsDisabled;
